import { Field } from "formik";
import clsx from "clsx";
import PropTypes from 'prop-types';

export const FormikInputGroup = ({id, type = 'text', label, labelHidden = false, placeholder, touched, error, className, onChange, onBlur, validate, ariaRequired = false, ...otherProps}) => {
    const styles = clsx(
                        "form-control form-control-grey",
                        className ? className : ''
                    );
    const showError = Boolean(touched && error);
    const errorId = `${id}-error`;

    return (
        <div className="form-group">
            {label && (
                <label htmlFor={id} className={labelHidden ? 'visually-hidden' : 'form-label'}>
                    {label}
                </label>
            )}
            <Field
                {...otherProps}
                id={id}
                className={styles}
                placeholder={placeholder}
                name={id}
                data-testid={id}
                type={type}
                onChange={onChange}
                onBlur={onBlur}
                validate={validate}
                aria-invalid={showError || undefined}
                aria-describedby={showError ? errorId : undefined}
                aria-required={ariaRequired || undefined}
            />
            {showError && <div id={errorId} role="alert" className="validation-error">{error}</div>}
        </div>
    );
}


FormikInputGroup.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.node,
    labelHidden: PropTypes.bool,
    placeholder: PropTypes.string,
    touched: PropTypes.any,
    error: PropTypes.any,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    validate: PropTypes.func,
    ariaRequired: PropTypes.bool,
}
